import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import { NumericalLozenge } from 'src/components/atoms/NumericalLozenge/NumericalLozenge';
import * as styles from './FacetPill.styles';

export type FacetPillIcon = 'collapsed' | 'expanded';

export interface FacetPillProps {
  activeCount: number;
  disabled?: boolean;
  icon?: FacetPillIcon;
  onClick: () => void;
  title: string;
}

const formatCount = (count: number): `${number}` | `${number}+` =>
  count > 9 ? '9+' : (`${count}` as `${number}`);

export const FacetPill = ({
  activeCount,
  disabled = false,
  icon,
  onClick,
  title,
}: FacetPillProps) => {
  const hasActiveOptions = activeCount > 0;

  return (
    <button
      aria-label={hasActiveOptions ? `${title}, ${activeCount} selected` : title}
      css={styles.pill}
      data-active={hasActiveOptions}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {title}
      {hasActiveOptions && <NumericalLozenge inverted value={formatCount(activeCount)} />}
      {icon && <Icon data-testid={`facet-pill-icon-${icon}`} name={icon} size="sm" />}
    </button>
  );
};
